import styled from '@emotion/styled';

export const iphone2divStyle: React.CSSProperties = {
  opacity: "1",
  flexDirection: "column",
  alignItems: "center",
};

export const landingBg1GoldStyle: React.CSSProperties = {
  marginLeft: "-50px",
};

export const IphoneMocksStyled = styled.div`
  /* position: absolute; */
//   top: 0%;
//   left: 12%;
  display: flex;
//   width: 100%;
  gap: 50px;
//   height: 100%;

  .iphone1div {
    display: flex;
    align-items: center;
  }

  .iphone2div {
    display: flex;
    align-items: flex-start;
    /* margin-top: -100px; */
  }

  .iphone1div,
  .iphone2div {
    position: relative;
    height: 700px;
    /* width: 100%; */
    /* background-color: bisque; */
    .iPhone1 {
      /* width: 100%; */
      height: 450px;
      display: flex;
      align-items: center;
      /* height: auto; */
      z-index: 1;
    }
    .iPhone2 {
      /* width: 100%; */
      height: 450px;
      z-index: 1;
    }
    .game-preview-container {
      /* background: red; */
      /* height: 100px; */
      width: 90%;
      position: absolute;
      top: 25%;
      left: 50%;
      transform: translate(-50%);
      z-index: 99;
      cursor: pointer;
    }

    img {
      /* width: 250px; */
      height: auto;
    }
  }

  // Phone: show only one image (hide 2nd)
  @media (max-width: 767px) {
    .iphone1div {
      display: none;
    }
    .iphone2div {
      /* background: red; */
      height: 324px !important;
      .iPhone2 {
        /* aspect-ratio: 1/2; */
        /* width: 80%; */
        height: 360px !important;

        /* height: 400px; */
        /* width: 80%; */
      }
    }
    .game-preview-container {
      width: 90%;
      position: absolute;
      top: 8% !important;
      left: 50%;
      transform: translate(-50%);
      z-index: 99;
      cursor: pointer;
    }
  }

  // Tablet
  @media (min-width: 768px) and (max-width: 1023px) {
    .iphone1div {
      display: none;
    }

    .iphone2div {
      height: 500px;
      display: flex;
      position: relative;
      align-items: center;
      margin-top: 0px;
      .iPhone2 {
        height: 400px;
      }
    }

    // .iphone img {
    //   width: 250px;
    // }
    & {
      display: flex;
      gap: 2px;
    }
  }

  // Desktop
  @media (min-width: 1024px) {
    margin-top: 70px !important;
    // .iphone img {
    //   width: 200px;
    // }
  }

  @media (min-width: 1480px) {
    // .iphone img {
    //   width: 250px;
    // }
  }
`;